/**
 * InviteIQ localStorage helpers.
 * Key: 'iq_pending' — stores the invite code from ?iq= URL param.
 * Key: 'iq_surface_katalog' — stores the first-touch creator katalog ID from public routes.
 */

const IQ_STORAGE_KEY = 'iq_pending';
const IQ_SURFACE_KEY = 'iq_surface_katalog';

// ── Invite code (explicit ?iq= token) ──

export function getPendingInviteIQ(): string | null {
  try {
    return localStorage.getItem(IQ_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setPendingInviteIQ(code: string): void {
  try {
    localStorage.setItem(IQ_STORAGE_KEY, code);
  } catch {
    // Storage unavailable
  }
}

export function clearPendingInviteIQ(): void {
  try {
    localStorage.removeItem(IQ_STORAGE_KEY);
  } catch {
    // Storage unavailable
  }
}

// ── Surface katalog ID (first-touch creator route) ──

export function getSurfaceKatalogId(): string | null {
  try {
    return localStorage.getItem(IQ_SURFACE_KEY);
  } catch {
    return null;
  }
}

/**
 * Store the first-touch surface katalog ID.
 * Only sets if no value already exists (first-touch wins).
 */
export function setSurfaceKatalogId(katalogId: string): void {
  try {
    if (!localStorage.getItem(IQ_SURFACE_KEY)) {
      localStorage.setItem(IQ_SURFACE_KEY, katalogId);
      console.log('[InviteIQ] First-touch surface katalog:', katalogId);
    }
  } catch {
    // Storage unavailable
  }
}

export function clearSurfaceKatalogId(): void {
  try {
    localStorage.removeItem(IQ_SURFACE_KEY);
  } catch {
    // Storage unavailable
  }
}
